import { useCallback, useState } from "react";
import { FormikHelpers } from "formik";
import axios from "axios";
import { routes } from "../../General";
import { User } from "../../../interface/user.interface";
import { InquiryParams, PolicyFormValues, PolicyOption } from "../schemas/policy.types";

export const useCubePolicyUpload = (user: User) => {
    const [policyOptions, setPolicyOptions] = useState<PolicyOption[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback(
        (query: InquiryParams, actions?: FormikHelpers<PolicyFormValues>) => {
            const canFetch = user.isAdmin || user.isBroker || (user.cdCliente && query.cdCliente === user.cdCliente);

            if (!canFetch) {
                actions?.setSubmitting(false);
                return;
            }

            setLoading(true);

            axios
                .post(`${routes.api}/health-disaster/get-policies-for-upload`, query)
                .then(resp => {
                    const cubeData: PolicyOption[] = resp.data.cubeData || [];
                    const policyOptions: PolicyOption[] = cubeData.map(item => ({
                        ...item,
                        policyValidations: item.policyValidations || [],
                    }));
                    setPolicyOptions(policyOptions);
                })
                .catch(error => {
                    console.error("Error al obtener pólizas para carga:", error);
                })
                .finally(() => {
                    setLoading(false);
                    actions?.setSubmitting(false);
                });
        },
        [user.isAdmin, user.isBroker, user.cdCliente]
    );

    return { policyOptions, loading, fetchData };
};
